import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import Time from "./Subsection1";
import Motivation from "./Subsection2";
import ApplicationsAndOffers from "./Subsection3";
import InitialContact from "./Subsection4";
import InitialContactResponses from "./Subsection4b";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface SearchProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const Search: FC<SearchProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("The Search", true);
  }, [toggleSection])

  useEffect(() => {
    if (subsection === "initial-contact-between-your-faculty-and-offering-institution" || subsection === "responses-to-other-prompts-initial-contact")
      toggleSection("The Search/Initial contact between your faculty and offering institution", true);
  }, [toggleSection, subsection])


  return (
    <>
      <BreadcrumbNav section="search" subsection={subsection} />

      <h1>The Search</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "time-spent" && <Time />}
      {subsection === "ultimate-motivation-for-the-search" && <Motivation />}
      {subsection === "applications-sent-and-offers-received" && <ApplicationsAndOffers />}
      {subsection === "initial-contact-between-your-faculty-and-offering-institution" && <InitialContact />}
      {subsection === "responses-to-other-prompts-initial-contact" && <InitialContactResponses />}

      <BottomNavigation />
    </>
  )
}

export default Search;